/**
 * axios 封装
 */
import axios from 'axios'
import { Message } from 'element-ui'
import router from '../router'
import config from '../config'
import storage from './storage'
import download from './download'

const LOGIN_EXPIRE = '登录过期'
const NETWORK_ERROR = '网络请求异常，请稍后重试'

export const ERR_OK = '000000'

// 创建 axios 实例对象，添加全局配置
const service = axios.create({
  // baseURL: config.baseApi,
  timeout: 1000 * 60 * 60,
})

// 在请求或者响应被then或catch处理前拦截它们。配置token,header使得不必每次请求接口都要加token
service.interceptors.request.use(
  config => {
    // 判断是否为完整URL（包含协议）
    const isFullUrl = /^http?:\/\//.test(config.url);

    // 只有在不是完整URL时才进行路径处理
    if (!isFullUrl) {
      const userList = ['fs', 'ws']
      const arr = config.url.split('/')
      if (process.env.NODE_ENV === 'development') {
        let isBaseUrlApi = false
        for (let i = 0; i < userList.length; i++) {
          if (arr.includes(userList[i])) {
            isBaseUrlApi = true
          }
        }
        // console.log(config.url)
        if (!isBaseUrlApi) {
          config.url = `/api${config.url}`
        }
      }

      if (process.env.NODE_ENV === 'production') {
        for (let i = 0; i < userList.length; i++) {
          const index = arr.indexOf(userList[i])
          if (index !== -1) {
            arr.splice(index, 1)
          }
        }
        config.url = arr.join('/')
      }
    }

    isRedirect = true
    const headers = config.headers
    const token = storage.getItem('token')
    if (!headers.Authorization && token) {
      headers.Authorization = token
    }
    return config
  },
  error => {
    return Promise.reject(error)
  },
)

// 响应拦截
let isRedirect = true

service.interceptors.response.use(
  res => {
    // 拦截下载，如果返回的是二进制文件流，会直接下载
    if (!download(res)) {
      return
    }
    let { code, data, msg, page } = res.data

    if (code === ERR_OK) {
      if (page) {
        return {
          data,
          page,
        }
      }
      return data
    } else if (code === '100401') {
      Message.error(LOGIN_EXPIRE)
      setTimeout(() => {
        router.push('/login')
      }, 1500)
      return Promise.reject(LOGIN_EXPIRE)
    } else {
      if (Object.prototype.toString.call(res.data) === '[object Blob]') {
        res.data.text().then(res => {
          const obj = JSON.parse(res)
          msg = obj.msg
          Message.error(msg || NETWORK_ERROR)
          return Promise.reject(msg || NETWORK_ERROR)
        })
      } else {
        code !== '301819' && Message.error(msg || NETWORK_ERROR)
        return Promise.reject(msg || NETWORK_ERROR)
      }
    }
  },
  error => {
    const { code, msg } = error.response.data
    if (code === '100401') {
      if (isRedirect) {
        Message.error(msg)
        router.push('/user/login')
        isRedirect = false
      }
      return Promise.reject(LOGIN_EXPIRE)
    }
    return Promise.reject(LOGIN_EXPIRE)
  },
)

/**
 * 请求核心函数
 * @param options 请求的配置
 * @returns {AxiosPromise}
 */
function request(options) {
  // 在 get 和 post 调用的时候统一传 data 为参数，但是在请求的时候把 get 的请求参数转换为 params
  options.method = options.method || 'get'
  if (options.method.toLowerCase() === 'get') {
    options.params = options.data
  }
  // 延迟
  if (options.timeout) {
    service.defaults.timeout = options.timeout
  }
  // config.mock 是控制全局接口，options.mock 可以在个别接口里边重新定义 mock 变量
  if (options.mock != null) {
    config.mock = options.mock
  }
  // 判断是否为完整URL（包含协议）
  const isFullUrl = /^http?:\/\//.test(options.url);

  if (!isFullUrl) {
    // 只有在不是完整URL时才设置 baseURL
    if (config.env === 'prod') {
      service.defaults.baseURL = config.baseApi
    } else {
      // 其他环境的 baseURL 设置
    }
  } else {
    // 如果是完整URL，临时清除 baseURL
    service.defaults.baseURL = ''
  }
  // if (config.env === 'prod') {
  //   service.defaults.baseURL = config.baseApi
  // } else {
  //   // console.log(service.defaults)
  //   // service.defaults.baseURL = config.mock ? config.mockApi : config.baseApi
  // }
  return service(options)
}

// 添加直接调用的方法：比如 this.$request.get() ......
;['get', 'post', 'put', 'delete', 'patch'].forEach(method => {
  request[method] = (url, data, options) => {
    // console.log(url)
    return request({
      url,
      data,
      method,
      ...options,
    })
  }
})

export default request
